import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { RouterModule } from '@angular/router';
import { InvoicePreviewService } from '../../services/invoice-preview.service';

@Component({
  selector: 'kt-app-invoice-preview',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './invoice-preview.component.html',
  styleUrls: ['./invoice-preview.component.scss']
})
export class InvoicePreviewComponent implements OnInit, OnDestroy {

  pdfUrl?: SafeResourceUrl;
  filename?: string;
  private subscription? : Subscription;

  private sanitizer = inject(DomSanitizer);
  private invoicePreviewService = inject(InvoicePreviewService);

  ngOnInit(): void {
    // Subscribe to PDF blob changes
    this.subscription = this.invoicePreviewService.pdfBlob$.subscribe(data => {
      if (data?.blob) {
        const url = URL.createObjectURL(data.blob);
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.filename = data.filename;
      } else {
        this.pdfUrl = undefined;
        this.filename = undefined;
      }
    });
  }

  downloadPdf() {
    if (!this.filename || !this.pdfUrl) return;

    // Since pdfUrl is a SafeResourceUrl, create a real object URL again from the blob
    this.invoicePreviewService.pdfBlob$.subscribe(data => {
      if (!data?.blob) return;

      const url = URL.createObjectURL(data.blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = this.filename!;
      a.click();
      URL.revokeObjectURL(url);
    }).unsubscribe(); // unsubscribe immediately to avoid leaks
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
